// cloudknit面料
import axios from 'axios';
import { joinUrl } from '@repo/utils';
import { getAppConfig } from '@/utils/env.ts';
import { cloudKnitFabricReg } from '@/utils/regexs.ts';

const { URL_PARSE_URL } = getAppConfig();

interface FabricResource {
  id: string,
  type: 'cloudknit' | 'style3d'
}

export const processFabricProperty = async (url: string): Promise<FabricResource> => {
  if (cloudKnitFabricReg.test(url)) {
    const match = url.match(cloudKnitFabricReg);
    if (match && match[1]) {
      return { id:match[1], type: 'cloudknit' };
    }
  }
  return Promise.reject();
};

export const parseStyle3dUShortUrlV3 = async (url: string) => {
  try {
    const response = await axios.get<string>(joinUrl(URL_PARSE_URL, `/api_v3/style3d/redirect?url=${url}`));
    return response.data;
  } catch (error) {
    console.error('Error fetching the real URL:', error);
    throw new Error('解析错误');
  }
};
